/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Storage_Bar_FreeInputs */



/**
* | output |
* | --- |
* | "{size} free" |
*
* @param {Storage_Bar_FreeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const storage_bar_free = /** @type {((inputs: Storage_Bar_FreeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storage_Bar_FreeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.size} frei`)
	return /** @type {LocalizedString} */ (`${i?.size} free`)
});